import type React from 'react'
import type { JSX, RefObject } from 'react'
import type { BORDERS, COLOR, INDENTS } from 'vars/index'

import { Children } from 'react'
import { FIXED_INDENTS } from 'vars/index'
import { TabsList } from './Tabs.styled'

export interface ITabsProps {
  nodeRef?: RefObject<HTMLDivElement | null>
  gap?: FIXED_INDENTS | INDENTS
  handleScroll?: () => void
  children: React.ReactNode
  paddings?: FIXED_INDENTS[]
  borderColor?: COLOR
  borderWidth?: BORDERS
  isFixedWidthTabs?: boolean
}

export const Tabs = ({
  gap = FIXED_INDENTS.INDENT_80,
  nodeRef,
  handleScroll,
  children,
  paddings,
  borderColor,
  borderWidth,
  isFixedWidthTabs,
}: ITabsProps): JSX.Element => {
  const countChildren = Children.count(children)
  return (
    <TabsList
      paddings={paddings}
      borderColor={borderColor}
      borderWidth={borderWidth}
      gap={gap}
      ref={nodeRef}
      onScroll={handleScroll}
      countChildren={countChildren}
      isFixedWidthTabs={isFixedWidthTabs}
    >
      {children}
    </TabsList>
  )
}
